import * as React from 'react';
import { DownloadBlock } from '../../../blocks.state';
import { ListLayout } from '../../downloadBlock/downloadBlock.layout';

export const NestedDownloadBlockLayout = (props: { title?: string; intro?: string; items: DownloadBlock['items'] }) => {
  return (
    <section className="block-nested block-nested--download block--download">
      <div className="block-nested__inner">
        {(props.title || props.intro) && (
          <header className="block-nested__header">
            {props.title && <h2 className="block-nested__title title--m">{props.title}</h2>}
            {props.intro && <p className="block-nested__intro" dangerouslySetInnerHTML={{ __html: props.intro }} />}
          </header>
        )}

        {props.items && props.items.length > 0 && <ListLayout listClassName="block-nested__list" items={props.items} nested />}
      </div>
    </section>
  )
}
